import { createContext, useContext } from 'react'
import { useSence, SenceIntegration } from './hooks'

interface ViewContextProps {
  sence: SenceIntegration
}

export const IntegrationsContext = createContext<ViewContextProps>(
  Object.create(null)
)

export const IntegrationsContextConsumer = IntegrationsContext.Consumer

export const useIntegrations = () => {
  const context = useContext(IntegrationsContext)
  if (context === undefined) {
    throw new Error(
      'useIntegrationsContext must be used within a IntegrationsProvider'
    )
  }
  return context
}

export const IntegrationsProvider: React.FC = ({ children }) => {
  const sence = useSence()
  return (
    <IntegrationsContext.Provider
      value={{
        sence,
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  )
}

export * from './hooks'
